import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../components/user/BCPAuthProvider";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  Tooltip,
  ButtonBase,
  useTheme
} from "@mui/material";

import { postNotification } from "../../components/utilities/Notifications";
import ModalLoadingFull from "../../components/modals/ModalLoadingFull";

import moment from "moment";
import "moment-timezone";

import { ContactTOModal } from "../events/components/EventAbout/EventAboutDefault";
import { userDisplayName } from "../events/components/EventFunctions";
import ArmyListComponent from "../events/components/ArmyListComponent";
import {
  findGetParameter,
  getData
} from "../../components/utilities/UtilityFunctions";
import {
  BCPCalendarDays,
  BCPShop,
  BCPUser
} from "../../components/icons/bcp/BCPIcons";
import Login from "../user/Login";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import { useTranslation } from "react-i18next";

export default function SubmitList() {
  const { t: tArmyList } = useTranslation("translation", {
    keyPrefix: "components.ArmyListComponent"
  });
  const { t: tGeneral } = useTranslation();
  let { playerId } = useParams();
  const armyListToken = findGetParameter("token");
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const theme = useTheme();
  const [loading, setLoading] = useState(true);
  const [player, setPlayer] = useState(null);
  const [event, setEvent] = useState(null);
  const [showLogin, setShowLogin] = useState(false);

  const [showArmyList, setShowArmyList] = useState(false);

  const [contactTOModal, setContactTOModal] = useState(false);

  useEffect(() => {
    const check = async () => {
      try {
        var apiEventData;
        var apiPlayerData = await getData(`/players/${playerId}`, {
          queryStringParameters: {
            armyListToken: armyListToken,
            "expand[]": ["event"]
          }
        });
        setPlayer(apiPlayerData);

        if (apiPlayerData.eventId) {
          apiEventData = await getData(`/events/${apiPlayerData.eventId}`, {
            queryStringParameters: {
              "expand[]": ["owner", "gameStore", "gameSystem"]
            }
          });

          if (apiEventData.photoFileId) {
            apiEventData.photo = await getData(
              `/files/${apiEventData.photoFileId}`,
              {
                queryStringParameters: {}
              }
            );
          }
          setEvent(apiEventData);
        }
        if (!apiEventData) {
          let err = new Error("Event not found");
          throw err;
        }
        if (
          !authContext?.authState?.identity?.userId ||
          authContext?.authState?.identity?.userId !== apiPlayerData.userId
        ) {
          if (armyListToken && !apiPlayerData.validArmyListToken) {
            let err = new Error(`Invalid email link.`);
            err.name = "Validation Error";
            throw err;
          }
        }

        if (
          apiEventData.started
          // && apiEventData.currentRound > 0
        ) {
          let err = new Error("Event has started");
          err.name = "Validation Error";
          throw err;
        }
        if (apiEventData.listSubmissionLocked) {
          let err = new Error(
            `The organizer has locked ${
              event?.gameSystem?.listLabel || "list"
            } submission`
          );
          err.name = "Validation Error";
          throw err;
        }

        setShowArmyList(true);
      } catch (err) {
        if (err.name === "Validation Error") {
          postNotification("error", err.message);
        } else {
          postNotification("error", err);
          navigate("/home");
        }
      }
      setLoading(false);
    };
    check();
    // eslint-disable-next-line
  }, []);

  if (showLogin) {
    return <Login />;
  }

  return (
    <>
      {loading && <ModalLoadingFull />}
      {!loading && (
        <Box sx={{ width: "100%" }}>
          <Container
            sx={{
              pt: 2,
              pb: 2
            }}
            maxWidth="lg"
          >
            <Box
              sx={{
                height: ["400px", "300px"],
                maxHeight: ["400px", "300px"],
                minHeight: ["400px", "300px"],
                overflow: "hidden",
                position: "absolute",
                top: "61px",
                left: 0,
                width: "100%",
                zIndex: "-1"
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: "0",
                  left: "0",
                  width: "100%"
                }}
              >
                <picture
                  content={
                    event?.photo?.url ||
                    event?.photoUrl ||
                    `${getEnvironmentVariable(
                      "SYSTEM_IMAGES_CLOUDFRONT"
                    )}/images/EventImage${
                      theme?.palette?.mode === "dark" ? "Dark" : ""
                    }.png`
                  }
                >
                  <source
                    srcset={
                      event?.photo?.url ||
                      event?.photoUrl ||
                      `${getEnvironmentVariable(
                        "SYSTEM_IMAGES_CLOUDFRONT"
                      )}/images/EventImage${
                        theme?.palette?.mode === "dark" ? "Dark" : ""
                      }.png`
                    }
                    sizes="100vw"
                  />
                  <img
                    data-automation="listing-hero-image"
                    alt=""
                    style={{
                      transform: "translate(-50%, -50%)",
                      filter: "blur(50px) brightness(.9)",
                      display: "inline-block",
                      width: "200%",
                      position: "relative",
                      top: "50%",
                      left: "50%"
                    }}
                  />
                </picture>
              </Box>
            </Box>
            <Grid container sx={{ gap: 2, mb: 2 }}>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12} sm={7}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        maxWidth: "100%",
                        minWidth: "100%",
                        paddingTop: "0px !important",
                        backgroundColor: "rgb(46 55 77 / 44%);",
                        "&:hover": {
                          opacity: [0.9, 0.8, 0.7]
                        }
                      }}
                    >
                      <img
                        src={
                          event?.photo?.url ||
                          event?.photoUrl ||
                          `${getEnvironmentVariable(
                            "SYSTEM_IMAGES_CLOUDFRONT"
                          )}/images/EventImage${
                            theme?.palette?.mode === "dark" ? "Dark" : ""
                          }.png`
                        }
                        alt={event?.name}
                        style={{ maxWidth: "100%", maxHeight: 300 }}
                      />
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={5}
                    sx={{
                      ml: [2],
                      mr: [-2],
                      display: "flex",
                      alignItems: "center",
                      maxWidth: [
                        "calc(100% - 36px) !important",
                        "calc(41.666667% - 36px) !important"
                      ],
                      minWidth: [
                        "calc(100% - 36px) !important",
                        "calc(41.666667% - 36px) !important"
                      ],
                      "& .MuiTypography-root": {
                        overflowWrap: "break-word",
                        wordWrap: "break-word"
                      }
                    }}
                  >
                    <Grid container>
                      <Grid item xs={12}>
                        <Typography variant="h4" gutterBottom>
                          <Link href={`/event/${event?.id}`} underline="none">
                            {event?.name}
                          </Link>
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography gutterBottom>
                          <Box
                            sx={{
                              minWidth: "35px",
                              verticalAlign: "bottom",
                              display: "inline-flex"
                            }}
                          >
                            <Tooltip title="Event Date">
                              <BCPCalendarDays
                                sx={{
                                  color: theme?.palette?.text?.secondary,
                                  verticalAlign: "bottom"
                                }}
                              />
                            </Tooltip>
                          </Box>
                          {(event?.timeZone
                            ? moment(event?.eventDate).tz(event?.timeZone)
                            : moment(event?.eventDate)
                          ).format("MMM Do, YYYY")}
                        </Typography>
                      </Grid>

                      {Boolean(event?.gameStoreName) && (
                        <Grid item xs={12}>
                          <Typography gutterBottom>
                            <Box
                              sx={{
                                minWidth: "35px",
                                verticalAlign: "bottom",
                                display: "inline-flex"
                              }}
                            >
                              <Tooltip title="Host Organisation">
                                <BCPShop
                                  sx={{
                                    color: theme?.palette?.text?.secondary,
                                    verticalAlign: "bottom"
                                  }}
                                />
                              </Tooltip>
                            </Box>
                            By {`${event?.gameStoreName}`.trim()}
                          </Typography>
                        </Grid>
                      )}
                      <Grid item xs={12}>
                        <Typography gutterBottom>
                          <Box
                            sx={{
                              minWidth: "35px",
                              verticalAlign: "bottom",
                              display: "inline-flex"
                            }}
                          >
                            <Tooltip title="Event Organizer">
                              <BCPUser
                                sx={{
                                  color: theme?.palette?.text?.secondary,
                                  verticalAlign: "bottom"
                                }}
                              />
                            </Tooltip>
                          </Box>
                          <Link
                            underline="none"
                            href="#"
                            onClick={(e) => {
                              setContactTOModal(true);
                            }}
                          >
                            {event?.ownerFirstName || event?.ownerLastName
                              ? userDisplayName(
                                  event?.ownerFirstName,
                                  event?.ownerLastName
                                )
                              : "Contact Organizer"}
                          </Link>
                          <ContactTOModal
                            open={contactTOModal}
                            setOpen={setContactTOModal}
                            authContext={authContext}
                            event={event}
                            tGeneral={tGeneral}
                          />
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              {!showArmyList && (
                <>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      p: 2
                    }}
                  >
                    <Typography variant="h3" gutterBottom>
                      Submit {event?.gameSystem?.listLabel || "List"}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      p: 2
                    }}
                  >
                    {event?.started ? (
                      //  && event?.currentRound > 0
                      <Typography variant="body1" paragraph>
                        This event has already started,{" "}
                        {event?.gameSystem?.listLabel || "list"} submission is
                        no longer available.
                      </Typography>
                    ) : event?.listSubmissionLocked ? (
                      <Typography variant="body1" paragraph>
                        The event organizer has locked{" "}
                        {event?.gameSystem?.listLabel || "list"}s.
                      </Typography>
                    ) : armyListToken &&
                      !player.validArmyListToken &&
                      !authContext?.authState?.identity?.userId ? (
                      <>
                        <Typography variant="body1" paragraph>
                          This email link has been used, and is a one use email.
                        </Typography>
                        <Typography variant="body1" paragraph>
                          You are not logged in. If this is your player record
                          please{" "}
                          <ButtonBase
                            color="warning"
                            variant="contained"
                            onClick={(e) => {
                              setShowLogin(true);
                            }}
                            sx={{
                              margin: "inherit",
                              mb: "-2px",
                              mt: "-4px",
                              fontFamily: "inherit",
                              fontWeight: "inherit",
                              fontSize: "inherit",
                              lineHeight: "inherit",
                              letterSpacing: "inherit",
                              color: "text.message"
                            }}
                          >
                            login
                          </ButtonBase>{" "}
                          and try again.
                        </Typography>
                      </>
                    ) : armyListToken &&
                      !player.validArmyListToken &&
                      authContext?.authState?.identity?.userId !==
                        player?.userId ? (
                      <>
                        <Typography variant="body1" paragraph>
                          This email link has been used, and is a one use email.
                        </Typography>
                        <Typography variant="body1" paragraph>
                          You are not logged in as this player record and only
                          the player and event organizer(s) can submit a{" "}
                          {event?.gameSystem?.listLabel || "list"} without a
                          valid email link.
                        </Typography>
                      </>
                    ) : (
                      <></>
                    )}
                  </Grid>
                </>
              )}
            </Grid>

            {showArmyList && player && event && (
              <>
                <ArmyListComponent
                  label={`Submit ${event?.gameSystem?.listLabel || "List"}`}
                  event={event}
                  player={player}
                  armyListToken={armyListToken}
                  setPlayer={(e) => {
                    if (
                      authContext?.authState?.identity?.userId !==
                      player?.userId
                    ) {
                      setPlayer({
                        ...player,
                        validArmyListToken: false
                      });
                      setShowArmyList(false);
                    }
                  }}
                  active
                  tArmyList={tArmyList}
                />
              </>
            )}
          </Container>
        </Box>
      )}
    </>
  );
}
